import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
// import { far } from '@fortawesome/free-regular-svg-icons';

import {
	faAlignCenter,
	faAngleDown,
	faAngleRight,
	faAngleUp,
	faArchive,
	faArrowAltCircleUp,
	faArrowCircleDown,
	faArrowCircleLeft,
	faArrowCircleRight,
	faArrowCircleUp,
	faAsterisk,
	faAward,
	faBars,
	faBell,
	faBook,
	faBookReader,
	faBriefcase,
	faBullhorn,
	faCalendar,
	faCalendarAlt,
	faCalendarCheck,
	faCalendarWeek,
	faCertificate,
	faChalkboard,
	faChalkboardTeacher,
	faChartBar,
	faCheck,
	faChevronCircleLeft,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faClipboard,
	faClipboardList,
	faClock,
	faCloud,
	faCog,
	faCogs,
	faColumns,
	faComment,
	faComments,
	faCommentDots,
	faCompress,
	faDollarSign,
	faDownload,
	faEdit,
	faEquals,
	faEllipsisV,
	faExchangeAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faExpand,
	faEye,
	faEyeSlash,
	faFile,
	faFileAlt,
	faFileArchive,
	faFileDoc,
	// faFileExcel,
	faFileExport,
	faFileImage,
	faFileImport,
	// faFilePdf,
	faFileMedical,
	faFileSignature,
	faFileUpload,
	faFileWord,
	faFilter,
	faFlag,
	faFolder,
	faFolderOpen,
	faFont,
	faGavel,
	faGlobeAmericas,
	faGraduationCap,
	faHandPointer,
	faHandPointUp,
	faHome,
	faInfo,
	faInfoCircle,
	faInbox,
	faKey,
	faLaptop,
	faLink,
	faList,
	faListAlt,
	faListOl,
	faLongArrowAltDown,
	faMinusCircle,
	faNotEqual,
	faPaperclip,
	faPencilAlt,
	faPen,
	faPiggyBank,
	faPlayCircle,
	faPlus,
	faPrint,
	faQuestion,
	faQuestionCircle,
	faRandom,
	faRedo,
	faSchool,
	faScroll,
	faSearch,
	faSearchPlus,
	faSlidersH,
	faSms,
	faSortAlphaDown,
	faSpellCheck,
	faSpinner,
	faStopwatch,
	faSquare,
	faStar,
	faStream,
	faSync,
	faTh,
	faTimes,
	faToolbox,
	faTrash,
	faUndo,
	faUser,
	faUsers,
	faUserGraduate,
	faUtensils,
	faArrowsAltV,
	faSave,
	faCheckCircle,
	faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

import {
	faFileExcel,
	faFilePdf,
	faFilePowerpoint
} from '@fortawesome/fontawesome-free-regular';

import {
	faDropbox,
	faGoogleDrive,
} from '@fortawesome/free-brands-svg-icons';



library.add(faDropbox);
library.add(faGoogleDrive);
library.add(faAlignCenter);
library.add(faAngleDown);
library.add(faAngleRight);
library.add(faAngleUp);
library.add(faArchive);
library.add(faArrowAltCircleUp);
library.add(faArrowCircleDown);
library.add(faArrowCircleLeft);
library.add(faArrowCircleRight);
library.add(faArrowCircleUp);
library.add(faAsterisk);
library.add(faAward);
library.add(faBars);
library.add(faBell);
library.add(faBook);
library.add(faBookReader);
library.add(faBriefcase);
library.add(faBullhorn);
library.add(faCalendar);
library.add(faCalendarAlt);
library.add(faCalendarCheck);
library.add(faCalendarWeek);
library.add(faCertificate);
library.add(faChalkboard);
library.add(faChalkboardTeacher);
library.add(faChartBar);
library.add(faCheck);
library.add(faCheckCircle);
library.add(faChevronCircleLeft);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faClipboard);
library.add(faClipboardList);
library.add(faClock);
library.add(faCloud);
library.add(faCog);
library.add(faCogs);
library.add(faColumns);
library.add(faComment);
library.add(faComments);
library.add(faCommentDots);
library.add(faCompress);
library.add(faDollarSign);
library.add(faDownload);
library.add(faEdit);
library.add(faEquals);
library.add(faFileExcel);
library.add(faEllipsisV);
library.add(faExchangeAlt);
library.add(faExclamation);
library.add(faExclamationCircle);
library.add(faExclamationTriangle);
library.add(faExpand);
library.add(faEye);
library.add(faEyeSlash);
library.add(faFile);
library.add(faFileAlt);
library.add(faFileArchive);
library.add(faFileExcel);
library.add(faFileExport);
library.add(faFileImage);
library.add(faFileImport);
library.add(faFileMedical);
library.add(faFilePdf);
library.add(faFilePowerpoint);
library.add(faFileSignature);
library.add(faFileUpload);
library.add(faFileWord);
library.add(faFilter);
library.add(faFlag);
library.add(faFolder);
library.add(faFolderOpen);
library.add(faFont);
library.add(faGavel);
library.add(faGlobeAmericas);
library.add(faGraduationCap);
library.add(faHandPointer);
library.add(faHandPointUp);
library.add(faHome);
library.add(faInfo);
library.add(faInfoCircle);
library.add(faInbox);
library.add(faKey);
library.add(faLaptop);
library.add(faLink);
library.add(faList);
library.add(faListAlt);
library.add(faListOl);
library.add(faMinusCircle);
library.add(faNotEqual);
library.add(faPaperclip);
library.add(faPencilAlt);
library.add(faPen);
library.add(faPiggyBank);
library.add(faPlayCircle);
library.add(faPlus);
library.add(faPrint);
library.add(faQuestion);
library.add(faQuestionCircle);
library.add(faRandom);
library.add(faRedo);
library.add(faSave);
library.add(faSchool);
library.add(faScroll);
library.add(faSearch);
library.add(faSearchPlus);
library.add(faSlidersH);
library.add(faSms);
library.add(faSortAlphaDown);
library.add(faSpinner);
library.add(faSpellCheck);
library.add(faStopwatch);
library.add(faSquare);
library.add(faStar);
library.add(faStream);
library.add(faSync);
library.add(faTh);
library.add(faTimes);
library.add(faTimesCircle);
library.add(faToolbox);
library.add(faTrash);
library.add(faUndo);
library.add(faUser);
library.add(faUsers);
library.add(faUserGraduate);
library.add(faUtensils);
library.add(faArrowsAltV);
library.add(faLongArrowAltDown);
